export default __webpack_public_path__ + "static/media/img-7.a423109b.jpg";